import {jsonMember, jsonObject} from "typedjson";

@jsonObject()
export class PitResponsibleUser {

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true })
  id: number;

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true })
  responsibilityTypeId: number;

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: true })
  userId: number;

  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: true })
  isTypeEditable: boolean;
}
